// xx59 product images
import XX59Mobile from '../../../../assets/product-xx59-headphones/mobile/image-product.jpg'
import XX59Tablet from '../../../../assets/product-xx59-headphones/tablet/image-product.jpg'
import XX59Desktop from '../../../../assets/product-xx59-headphones/desktop/image-product.jpg'

// xx99MarkOne product images
import XX99MarkOneMobile from '../../../../assets/product-xx99-mark-one-headphones/mobile/image-product.jpg'
import XX99MarkOneTablet from '../../../../assets/product-xx99-mark-one-headphones/tablet/image-product.jpg'
import XX99MarkOneDesktop from '../../../../assets/product-xx99-mark-one-headphones/desktop/image-product.jpg'

// xx99MarkTwo product images
import XX99MarkTwoMobile from '../../../../assets/product-xx99-mark-two-headphones/mobile/image-product.jpg'
import XX99MarkTwoTablet from '../../../../assets/product-xx99-mark-two-headphones/tablet/image-product.jpg'
import XX99MarkTwoDesktop from '../../../../assets/product-xx99-mark-two-headphones/desktop/image-product.jpg'

// YXOne product images
import YXOneMobile from '../../../../assets/product-yx1-earphones/mobile/image-product.jpg'
import YXOneTablet from '../../../../assets/product-yx1-earphones/tablet/image-product.jpg'
import YXOneDesktop from '../../../../assets/product-yx1-earphones/desktop/image-product.jpg'

// ZX7 product images
import ZX7Mobile from '../../../../assets/product-zx7-speaker/mobile/image-product.jpg'
import ZX7Tablet from '../../../../assets/product-zx7-speaker/tablet/image-product.jpg'
import ZX7Desktop from '../../../../assets/product-zx7-speaker/desktop/image-product.jpg'

// ZX9 product images
import ZX9Mobile from '../../../../assets/product-zx9-speaker/mobile/image-product.jpg'
import ZX9Tablet from '../../../../assets/product-zx9-speaker/tablet/image-product.jpg'
import ZX9Desktop from '../../../../assets/product-zx9-speaker/desktop/image-product.jpg'

// GALLERY IMAGES XX59
import XX59Mobile1 from '../../../../assets/product-xx59-headphones/mobile/image-gallery-1.jpg'
import XX59Mobile2 from '../../../../assets/product-xx59-headphones/mobile/image-gallery-2.jpg'
import XX59Mobile3 from '../../../../assets/product-xx59-headphones/mobile/image-gallery-3.jpg'
import XX59Tablet1 from '../../../../assets/product-xx59-headphones/tablet/image-gallery-1.jpg'
import XX59Tablet2 from '../../../../assets/product-xx59-headphones/tablet/image-gallery-2.jpg'
import XX59Tablet3 from '../../../../assets/product-xx59-headphones/tablet/image-gallery-3.jpg'
import XX59Desktop1 from '../../../../assets/product-xx59-headphones/desktop/image-gallery-1.jpg'
import XX59Desktop2 from '../../../../assets/product-xx59-headphones/desktop/image-gallery-2.jpg'
import XX59Desktop3 from '../../../../assets/product-xx59-headphones/desktop/image-gallery-3.jpg'

// GALLERY IMAGES XX99 Mark One
import XX99MarkOneMobile1 from '../../../../assets/product-xx99-mark-one-headphones/mobile/image-gallery-1.jpg'
import XX99MarkOneMobile2 from '../../../../assets/product-xx99-mark-one-headphones/mobile/image-gallery-2.jpg'
import XX99MarkOneMobile3 from '../../../../assets/product-xx99-mark-one-headphones/mobile/image-gallery-3.jpg'
import XX99MarkOneTablet1 from '../../../../assets/product-xx99-mark-one-headphones/tablet/image-gallery-1.jpg'
import XX99MarkOneTablet2 from '../../../../assets/product-xx99-mark-one-headphones/tablet/image-gallery-2.jpg'
import XX99MarkOneTablet3 from '../../../../assets/product-xx99-mark-one-headphones/tablet/image-gallery-3.jpg'
import XX99MarkOneDesktop1 from '../../../../assets/product-xx99-mark-one-headphones/desktop/image-gallery-1.jpg'
import XX99MarkOneDesktop2 from '../../../../assets/product-xx99-mark-one-headphones/desktop/image-gallery-2.jpg'
import XX99MarkOneDesktop3 from '../../../../assets/product-xx99-mark-one-headphones/desktop/image-gallery-3.jpg'

// GALLERY IMAGES XX99 Mark Two
import XX99MarkTwoMobile1 from '../../../../assets/product-xx99-mark-two-headphones/mobile/image-gallery-1.jpg'
import XX99MarkTwoMobile2 from '../../../../assets/product-xx99-mark-two-headphones/mobile/image-gallery-2.jpg'
import XX99MarkTwoMobile3 from '../../../../assets/product-xx99-mark-two-headphones/mobile/image-gallery-3.jpg'
import XX99MarkTwoTablet1 from '../../../../assets/product-xx99-mark-two-headphones/tablet/image-gallery-1.jpg'
import XX99MarkTwoTablet2 from '../../../../assets/product-xx99-mark-two-headphones/tablet/image-gallery-2.jpg'
import XX99MarkTwoTablet3 from '../../../../assets/product-xx99-mark-two-headphones/tablet/image-gallery-3.jpg'
import XX99MarkTwoDesktop1 from '../../../../assets/product-xx99-mark-two-headphones/desktop/image-gallery-1.jpg'
import XX99MarkTwoDesktop2 from '../../../../assets/product-xx99-mark-two-headphones/desktop/image-gallery-2.jpg'
import XX99MarkTwoDesktop3 from '../../../../assets/product-xx99-mark-two-headphones/desktop/image-gallery-3.jpg'

// GALLERY IMAGES YX1 Earphones
import YX1EarphonesMobile1 from '../../../../assets/product-yx1-earphones/mobile/image-gallery-1.jpg'
import YX1EarphonesMobile2 from '../../../../assets/product-yx1-earphones/mobile/image-gallery-2.jpg'
import YX1EarphonesMobile3 from '../../../../assets/product-yx1-earphones/mobile/image-gallery-3.jpg'
import YX1EarphonesTablet1 from '../../../../assets/product-yx1-earphones/tablet/image-gallery-1.jpg'
import YX1EarphonesTablet2 from '../../../../assets/product-yx1-earphones/tablet/image-gallery-2.jpg'
import YX1EarphonesTablet3 from '../../../../assets/product-yx1-earphones/tablet/image-gallery-3.jpg'
import YX1EarphonesDesktop1 from '../../../../assets/product-yx1-earphones/desktop/image-gallery-1.jpg'
import YX1EarphonesDesktop2 from '../../../../assets/product-yx1-earphones/desktop/image-gallery-2.jpg'
import YX1EarphonesDesktop3 from '../../../../assets/product-yx1-earphones/desktop/image-gallery-3.jpg'

// GALLERY IMAGES ZX7 Speakers
import ZX7SpeakersMobile1 from '../../../../assets/product-zx7-speaker/mobile/image-gallery-1.jpg'
import ZX7SpeakersMobile2 from '../../../../assets/product-zx7-speaker/mobile/image-gallery-2.jpg'
import ZX7SpeakersMobile3 from '../../../../assets/product-zx7-speaker/mobile/image-gallery-3.jpg'
import ZX7SpeakersTablet1 from '../../../../assets/product-zx7-speaker/tablet/image-gallery-1.jpg'
import ZX7SpeakersTablet2 from '../../../../assets/product-zx7-speaker/tablet/image-gallery-2.jpg'
import ZX7SpeakersTablet3 from '../../../../assets/product-zx7-speaker/tablet/image-gallery-3.jpg'
import ZX7SpeakersDesktop1 from '../../../../assets/product-zx7-speaker/desktop/image-gallery-1.jpg'
import ZX7SpeakersDesktop2 from '../../../../assets/product-zx7-speaker/desktop/image-gallery-2.jpg'
import ZX7SpeakersDesktop3 from '../../../../assets/product-zx7-speaker/desktop/image-gallery-3.jpg'

// GALLERY IMAGES ZX9 Speakers
import ZX9SpeakersMobile1 from '../../../../assets/product-zx9-speaker/mobile/image-gallery-1.jpg'
import ZX9SpeakersMobile2 from '../../../../assets/product-zx9-speaker/mobile/image-gallery-2.jpg'
import ZX9SpeakersMobile3 from '../../../../assets/product-zx9-speaker/mobile/image-gallery-3.jpg'
import ZX9SpeakersTablet1 from '../../../../assets/product-zx9-speaker/tablet/image-gallery-1.jpg'
import ZX9SpeakersTablet2 from '../../../../assets/product-zx9-speaker/tablet/image-gallery-2.jpg'
import ZX9SpeakersTablet3 from '../../../../assets/product-zx9-speaker/tablet/image-gallery-3.jpg'
import ZX9SpeakersDesktop1 from '../../../../assets/product-zx9-speaker/desktop/image-gallery-1.jpg'
import ZX9SpeakersDesktop2 from '../../../../assets/product-zx9-speaker/desktop/image-gallery-2.jpg'
import ZX9SpeakersDesktop3 from '../../../../assets/product-zx9-speaker/desktop/image-gallery-3.jpg'


export const ProductImages = [
    {
        slug: 'xx99-mark-two-headphones',
        images: {
            mobile: XX99MarkTwoMobile,
            tablet: XX99MarkTwoTablet,
            desktop:XX99MarkTwoDesktop
        }
    },
    {
        slug: 'xx99-mark-one-headphones',
        images: {
            mobile: XX99MarkOneMobile,
            tablet: XX99MarkOneTablet,
            desktop:XX99MarkOneDesktop
        }
    },
    {
        slug: 'xx59-headphones',
        images: {
            mobile: XX59Mobile,
            tablet: XX59Tablet,
            desktop: XX59Desktop
        }
    },
    {
        slug: 'zx9-speaker',
        images: {
            mobile: ZX9Mobile,
            tablet: ZX9Tablet,
            desktop: ZX9Desktop
        }
    },
    {
        slug: 'zx7-speaker',
        images: {
            mobile: ZX7Mobile,
            tablet: ZX7Tablet,
            desktop: ZX7Desktop
        }
    },
    {
        slug: 'yx1-earphones',
        images: {
            mobile: YXOneMobile,
            tablet: YXOneTablet,
            desktop: YXOneDesktop
        }
    }
]

export const ProductGallery = [
    {
        slug: 'xx99-mark-two-headphones',
        images: {
            mobile: [XX99MarkTwoMobile1, XX99MarkTwoMobile2, XX99MarkTwoMobile3],
            tablet: [XX99MarkTwoTablet1, XX99MarkTwoTablet2, XX99MarkTwoTablet3],
            desktop: [XX99MarkTwoDesktop1, XX99MarkTwoDesktop2, XX99MarkTwoDesktop3]
        }
    },
    {
        slug: 'xx99-mark-one-headphones',
        images: {
            mobile: [XX99MarkOneMobile1, XX99MarkOneMobile2, XX99MarkOneMobile3],
            tablet: [XX99MarkOneTablet1, XX99MarkOneTablet2, XX99MarkOneTablet3],
            desktop: [XX99MarkOneDesktop1, XX99MarkOneDesktop2, XX99MarkOneDesktop3]
        }
    },
    {
        slug: 'xx59-headphones',
        images: {
            mobile: [XX59Mobile1, XX59Mobile2, XX59Mobile3],
            tablet: [XX59Tablet1, XX59Tablet2, XX59Tablet3],
            desktop: [XX59Desktop1, XX59Desktop2, XX59Desktop3]
        }
    },
    {
        slug: 'zx9-speaker',
        images: {
            mobile: [ZX9SpeakersMobile1, ZX9SpeakersMobile2, ZX9SpeakersMobile3],
            tablet: [ZX9SpeakersTablet1, ZX9SpeakersTablet2, ZX9SpeakersTablet3],
            desktop: [ZX9SpeakersDesktop1, ZX9SpeakersDesktop2, ZX9SpeakersDesktop3]
        }
    },
    {
        slug: 'zx7-speaker',
        images: {
            mobile: [ZX7SpeakersMobile1, ZX7SpeakersMobile2, ZX7SpeakersMobile3],
            tablet: [ZX7SpeakersTablet1, ZX7SpeakersTablet2, ZX7SpeakersTablet3],
            desktop: [ZX7SpeakersDesktop1, ZX7SpeakersDesktop2, ZX7SpeakersDesktop3]
        }
    },
    {
        slug: 'yx1-earphones',
        images: {
            mobile: [YX1EarphonesMobile1, YX1EarphonesMobile2, YX1EarphonesMobile3],
            tablet: [YX1EarphonesTablet1, YX1EarphonesTablet2, YX1EarphonesTablet3],
            desktop: [YX1EarphonesDesktop1, YX1EarphonesDesktop2, YX1EarphonesDesktop3]
        }
    }
]